import { observer } from 'mobx-react';
import { PROFILER_SEARCH_CATEGORY_FIELDS } from '../../../../utils/constants/fields';
import Radio from '../../../../components/inputs/Radio';
import { useStore } from '../../../../store/store';
import { ICON_BUTTON_ICONS } from '../../../../components/buttons/IconButton';
import BulkFileDropzone, { BULK_DEMO_UPLOAD_HINT } from './BulkFileDropzone';

const ProfilerCompanyBulkSearchFormDesktop = observer(
  ({
    onSearch,
    file,
    onFileChange,
    tabs,
    categoryFields,
    setCategoryFieldValue,
    categoryOptions,
    loading = false,
    progress = null
  }) => {
    const { utilsStore, profilerAccessStore } = useStore();
    if (utilsStore.windowWidth < 1201) {
      return null;
    }

    return (
      <div className="formform desktop">
        <div className="fields-area">
          {tabs}
          <div className="row category-group">
            <Radio
              field={PROFILER_SEARCH_CATEGORY_FIELDS.SEARCH_CATEGORY}
              value={categoryFields[PROFILER_SEARCH_CATEGORY_FIELDS.SEARCH_CATEGORY.NAME]}
              setFieldValue={setCategoryFieldValue}
              values={categoryOptions}
              disabled={loading}
            />
          </div>
          <div className="flip-vertical-fields-area">
            {profilerAccessStore.isProfilerDemo && (
              <div
                className={`profiler-demo-info-message${
                  profilerAccessStore.demoSearchExceededLimit ? ' exceeded' : ''
                }`}
              >
                <div className="img-wrap">
                  <img src={ICON_BUTTON_ICONS.EXCLAMATAION_CIRCLE} />
                </div>
                <div className="text">
                  {profilerAccessStore.demoSearchExceededLimit ? (
                    <>
                      You&apos;ve used all {profilerAccessStore.demoSearchMaxCount} demo searches -
                      upgrade to full access to continue exploring.
                    </>
                  ) : (
                    <>
                      You have {profilerAccessStore.demoSearchRemainingCount} out of{' '}
                      {profilerAccessStore.demoSearchMaxCount} demo searches remaining - upgrade to
                      full access to unlock unlimited searches.
                    </>
                  )}
                </div>
              </div>
            )}
            <BulkFileDropzone
              file={file}
              onFileChange={onFileChange}
              loading={loading}
              progress={progress}
              disabled={profilerAccessStore.isProfilerDemo}
              disabledHint={BULK_DEMO_UPLOAD_HINT}
            />
            <div className="row">
              <div className="col"></div>
              <div className="col"></div>
              <div className="col search-btn-wrap">
                <button
                  type="button"
                  className="btn btn-primary disable-fade-primary"
                  disabled={!file || loading || profilerAccessStore.isProfilerDemo}
                  onClick={() => onSearch(file)}
                >
                  Search
                </button>
              </div>
            </div>
            <div className="fields-area-mandatory-row">
              <font className="red-asterisk">*</font>mandatory fields
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default ProfilerCompanyBulkSearchFormDesktop;
